import { Component, OnInit,  ViewChild, ElementRef } 			  from '@angular/core';
import { Router, ActivatedRoute }                                 from '@angular/router';
import { first }                                                  from 'rxjs/operators';
import { NgxSpinnerService }                                      from 'ngx-spinner';

import { AlertService, LunchpageService }                         from '../_services';
import { Globals  }                                               from '../_helpers';
import config                                                     from '../../config';

@Component({
  selector: 'adaptive-start-test',
  templateUrl: './adaptive-launch-page.component.html',
})

export class AdaptiveLaunchpageComponent implements OnInit{
@ViewChild('openBtn') openBtn: ElementRef;
	userData = {};
	settings = {};
	instructions = [];
	loading = false;
	isCalled = true;
	returnUrl : string;
    isAllowViva = false;
    isAllowPsycho = false;
    isTheory = false;
    geoIPData = {};
    geoIP = '';
    city = '';
    region = '';
    postal = '';
    loc = '';
    countryip = ''; 
    videostream = 0; 
    feedsetting = {};  
    chooseDL: number = 0;
	select: number = 0;

	constructor(
        private route: ActivatedRoute,
        private router: Router,
        private lunchpageService: LunchpageService,
        private alertService: AlertService,
        private globals: Globals,
        private spinner: NgxSpinnerService
    ) {}

    ngOnInit() {

        var step = this.route.snapshot.paramMap.get("step");
        if(step != this.globals.complSteps['adaptive-test-start'])

        this.userData = JSON.parse(localStorage.getItem('currentUser'));
        this.settings = JSON.parse(sessionStorage.pkshn_exam_set);
        // console.log('examstatus '+this.userData['examstatus']);
        // console.log('viva_assessor '+this.settings['viva_assessor']);
        // console.log('module '+this.settings['module']);
        // console.log('viva_first '+this.settings['viva_first']);
        // console.log('viva_assessor '+this.settings['viva_assessor']);
        
        if(this.userData['examstatus'] === undefined)
        {
            this.spinner.show();
            window.location.reload();
            return;
        }
        if((this.settings['entered_adaptive'] == 1) && (this.settings['adaptive_type'] == 1))
        {
            this.chooseDL = 1;
            this.getmyDL();
        } 
        else if((this.settings['entered_adaptive'] == 1) && (this.settings['adaptive_type'] == 2))
        {
            this.chooseDL = 2;
        } 
        else
        {
            this.chooseDL = 0;
        }       
              
        this.getInstruction();
 
        // get return url from route parameters or default to '/'
        this.returnUrl = '/';
        // console.log('isAllowViva '+this.isAllowViva);
        // console.log('isTheory '+this.isTheory);
    }

inspdf;
insvideo;
    private getInstruction(){
        this.spinner.show();
        this.lunchpageService.getInstructionsAdaptive(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){
                    this.inspdf = data.pdf_url; 
                    this.insvideo = data.video_link;                     
                    if(data.feed.session != '')
                    {
                         /* set opentalk sessionid and token */
                        //config.SESSION_ID = data.feed.session;
                        //config.TOKEN = data.feed.token; 
                        this.videostream = 1;  
                        let feedsetting = {'sessid':data.feed.session, 'toid':data.feed.token};
                        sessionStorage.setItem('pkshn_feedsetting',JSON.stringify(feedsetting));                   
                    }
                    else
                    {
                        this.videostream = 0;
                    }
                   
                	let inst = (data.instruction).split('\n');
                	for (var i = 0; i < inst.length; ++i) {
                		let html = inst[i];
                        if(html != '')
                		  this.instructions[i] = {index:i+1, text:html};
                	}
                    this.spinner.hide();

                    /* set student geo location */
                    //this.setGeoLocation();
                }
                else if(data.status == 1001){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.spinner.hide();
                }
            },
            error => {
                this.spinner.hide();
            }
        );
    }
    dlArrLength;
    dllist = [];
    private getmyDL(){
        //this.spinner.show();
        this.lunchpageService.getmyDL(this.globals.root_url, this.userData['usercode'], this.userData['userid'], this.userData['subuserid'], this.userData['id'], this.settings['exam_id'])
        .pipe(first())
        .subscribe(
            data => {
                if(data.code == 1000){                                   
                    this.dllist = data.dl_list;
                    this.dlArrLength = this.dllist.length;
                    this.spinner.hide();
                }
                else if(data.status == 1001){
                    this.loading = false;
                    this.router.navigateByUrl('/login');
                }
                else{
                    this.spinner.hide();
                }
            },
            error => {
                this.spinner.hide();
            }
        );
    }


    public adaptivePaper(videosetting){
        //console.log(videosetting);return;
        if(videosetting == 1)
        {
            var parms = this.globals.getRandUrl('theory-test');
            if(this.select == 0)
            {
                this.router.navigateByUrl('/adaptive-test-wls/'+parms); 
            }
            else
            {
                this.router.navigateByUrl('/adaptive-test-wls/'+parms+"/"+this.select);
            }            
            //window.open("localhost:4200/theory-test")
        }
        else
        { 
            var parms = this.globals.getRandUrl('adaptive-theory-test');
            //console.log('/adaptive-test/'+parms+"/"+this.select);
            if(this.select == 0)
            {
                this.router.navigateByUrl('/adaptive-test/'+parms); 
            }
            else
            {
                this.router.navigateByUrl('/adaptive-test/'+parms+"/"+this.select);
            }
            //this.router.navigateByUrl('/adaptive-test/'+parms+"/"+this.select);
            //window.open("localhost:4200/theory-test-nols")
        }
    }   
    openModal() {
    this.openBtn.nativeElement.click();
    }    
    
    dlSelected(e, dlid)
    { 
        //this.spinner.show();
        var currentOptBtn = document.getElementById('op-' + dlid) as HTMLInputElement;
        if(currentOptBtn.checked == true)
        {
            this.select = dlid;
        }
        else{
            this.select = 0;          
        }
        //console.log(this.select);

    }

}
